<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="updateAsset">
            <v-card style="position: relative;">
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Update Asset Groups</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>
                <v-overlay :model-value="!formReady" contained class="align-center justify-center">
                    <v-progress-circular indeterminate color="primary"/>
                </v-overlay>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col class="py-0" cols="12" sm="12">
                            <v-select v-model="formData['asset_group_ids']" :items="assetGroups"
                                      :rules="[vRules.required]" density="compact" item-title="name" item-value="id"
                                      label="Asset Group" multiple>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button" @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useLoadingStore} from "@/stores/loadingStore";
import {useSnackbarStore} from "@/stores/snackBarStore";

const formReady = ref(false);
const assetGroups = ref([]);
const loadingStore = useLoadingStore();
const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    asset: {
        type: Object
    }
});

const formData = reactive({
    valid: false,
    label: props.asset.label ?? null,
    status: props.asset.status ?? null,
    company_id: props.asset.company_id ?? null,
    device_id: props.asset.device_id ?? null,
    asset_type_id: props.asset.asset_type_id ?? null,
    asset_group_ids: props.asset.asset_groups?.map(group => group.id) ?? [],
});

const emits = defineEmits(['update:modelValue', 'updateAsset']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

onMounted(() => {
    Promise.all([fetchAssetGroups(false)]).finally(() => formReady.value = true);
})
const fetchAssetGroups = (reset = true) => {
    reset ? formData['asset_group_ids'] = null : '';
    return send('get', `asset-groups?list=true&company=${formData['company_id']}`)
        .then((response) => {
            assetGroups.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Companies could not be loaded', 'error')
        })
}
const updateAsset = () => {
    errors.value = [];
    loadingStore.showLoading('Updating...', 'Please wait while we save your changes');
    send('put', `assets/${props.asset.id}`, formData)
        .then((response) => {
            showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateAsset', response.data.data.asset);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
        .finally(() => loadingStore.hideLoading());
}

</script>
